<template>
  <div>
    <ProgressSpinner />
  </div>
</template>

<script>
import api from "@/api";

export default {
  components: {},
  data() {},
  created() {},
  mounted() {
    setTimeout(() => {
      this.reconnectSportsengine();
    }, 500);
  },
};
</script>

<style scoped lang="scss"></style>
